import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/FormControl/form-control';
import { css } from '@patternfly/react-styles';
import { ValidatedOptions } from '../../helpers/constants';
export var FormSelect =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FormSelect, _React$Component);

  function FormSelect(props) {
    var _this;

    _classCallCheck(this, FormSelect);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FormSelect).call(this, props));

    _this.handleChange = function (event) {
      _this.props.onChange(event.currentTarget.value, event);
    };

    if (!props.id && !props['aria-label']) {
      // eslint-disable-next-line no-console
      console.error('FormSelect requires either an id or aria-label to be specified');
    }

    return _this;
  }

  _createClass(FormSelect, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          children = _a.children,
          className = _a.className,
          value = _a.value,
          validated = _a.validated,
          isDisabled = _a.isDisabled,
          isRequired = _a.isRequired,
          props = __rest(_a, ["children", "className", "value", "validated", "isDisabled", "isRequired"]);

      return React.createElement("select", Object.assign({}, props, {
        className: css(styles.formControl, className, validated === ValidatedOptions.success && styles.modifiers.success),
        "aria-invalid": validated === ValidatedOptions.error,
        onChange: this.handleChange,
        disabled: isDisabled,
        required: isRequired,
        value: value
      }), children);
    }
  }]);

  return FormSelect;
}(React.Component);
FormSelect.defaultProps = {
  className: '',
  value: '',
  validated: 'default',
  isDisabled: false,
  isRequired: false,
  onBlur: function onBlur() {
    return undefined;
  },
  onFocus: function onFocus() {
    return undefined;
  },
  onChange: function onChange() {
    return undefined;
  }
};